// Minimal typed wrapper around window.Telegram.WebApp
declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initData: string
        initDataUnsafe: { user?: { id: number; first_name: string; language_code?: string } }
        colorScheme: 'light' | 'dark'
        expand(): void
        ready(): void
        close(): void
        BackButton: {
          isVisible: boolean
          show(): void
          hide(): void
          onClick(fn: () => void): void
          offClick(fn: () => void): void
        }
        MainButton: {
          text: string
          isVisible: boolean
          isActive: boolean
          setText(text: string): void
          show(): void
          hide(): void
          enable(): void
          disable(): void
          onClick(fn: () => void): void
          offClick(fn: () => void): void
        }
        HapticFeedback: {
          impactOccurred(style: 'light' | 'medium' | 'heavy'): void
          notificationOccurred(type: 'error' | 'success' | 'warning'): void
        }
      }
    }
  }
}

export function useTelegram() {
  const tg = window.Telegram?.WebApp

  return {
    tg,
    initData: tg?.initData ?? '',
    user: tg?.initDataUnsafe?.user,
    isDark: tg?.colorScheme === 'dark',
    expand: () => tg?.expand(),
    ready: () => tg?.ready(),
    haptic: tg?.HapticFeedback,
  }
}
